<div class="units-groups-wrapper">
    <div class="title-tabs-row">
        <div class="title-group">
            <span class="title">Boligtyper </span>
            <span class="grey">fordelt på...</span>
        </div>
        <div class="tabs">
            <button class="tab" [class.active]="mode() === 'rom'" (click)="setMode('rom')">Rom</button>
            <button class="tab" [class.active]="mode() === 'etg'" (click)="setMode('etg')">Etg</button>
        </div>
    </div>

    @if (mode() === 'rom') {
        <rooms-groups [rooms]="roomsGroups()"></rooms-groups>
    } @else {
        <floors-groups [floors]="floorsGroups()"></floors-groups>
    }
</div>
